import React from 'react';
import PropTypes from 'prop-types';
import Typography from '../../../../components/Typography/Typography';
import Grid from '../../../../components/Grid/Grid';

const CreatePilotTransferSuccess = ({ pilotTransferId }) => (
  <Grid container direction="column" gap={0.5} sx={{ py: 1 }}>
    <Typography variant="subtitle1">
      試燒移轉單建立成功！ Berhasil membuat tes pembakaran
    </Typography>
    <Typography variant="subtitle1">
      試燒移轉單號 / Nomor tes pembakaran：<strong>{pilotTransferId}</strong>
    </Typography>
  </Grid>
);

CreatePilotTransferSuccess.propTypes = {
  pilotTransferId: PropTypes.string.isRequired,
};

export default CreatePilotTransferSuccess;
